import React from 'react';
import { inp, lbl, noAutofill, row2 } from './shared';

export default function Consent({ data, onChange }) {
  const fullName = [data.firstName, data.middleName, data.lastName].filter(Boolean).join(' ');
  const displayName = fullName || '';

  return (
    <div>
      <p style={copy}>
        I <strong>{displayName}</strong> give my permission to Translating Insurance to serve as the health
        insurance agent or broker for myself and my entire household if applicable, for purposes of enrollment
        in a Qualified Health Plan offered on the Federally Facilitated Marketplace. By consenting to this
        agreement, I authorize the above-mentioned Agency to view and use the confidential information provided
        by me in writing, electronically, or by telephone only for the purposes of one or more of the following:
      </p>

      <ol style={list}>
        <li>Searching for an existing Marketplace application;</li>
        <li>Completing an application for eligibility and enrollment in a Marketplace Qualified Health Plan or other government insurance affordability programs, such as Medicaid and CHIP or advance tax credits to help pay for Marketplace premiums;</li>
        <li>Providing ongoing account maintenance and enrollment assistance, as necessary; or</li>
        <li>Responding to inquiries from the Marketplace regarding my Marketplace application.</li>
      </ol>

      <p style={copy}>
        I understand that the Agency will not use or share my personally identifiable information (PII) for any
        purposes other than those listed above. The Agency will ensure that my PII is kept private and safe when
        collecting, storing, and using my PII for the stated purposes above.
      </p>

      <p style={copy}>
        I confirm that the information I provide for entry on my Marketplace eligibility and enrollment application
        will be true to the best of my knowledge. I understand that I do not have to share additional personal
        information about myself or my health with my Agent beyond what is required on the application for
        eligibility and enrollment purposes. I understand that my consent remains in effect until I revoke it, and
        I may revoke or modify my consent at any time by email or phone.
      </p>

      <div style={{ marginBottom: 18 }}>
        <label style={lbl}>Name of Primary Household Contact and/or Authorized Representative</label>
        <input style={inp} value={fullName} readOnly />
      </div>

      <div style={row2}>
        <div>
          <label style={lbl}>Phone Number</label>
          <input style={inp} value={data.phone} readOnly />
        </div>
        <div>
          <label style={lbl}>Email Address</label>
          <input style={inp} value={data.email} readOnly />
        </div>
      </div>

      <ConsentSignature data={data} onChange={onChange} />

      <div style={agentBox}>
        <div style={agentTitle}>Agent and Agency Information</div>
        <div style={row2}>
          <Field label="Name of Primary Writing Agent" value={data.primaryWritingAgent || 'Jacquie Walter'} onChange={v => onChange('primaryWritingAgent', v)} />
          <Field label="Agent National Producer Number" value={data.agentNpn || ''} onChange={v => onChange('agentNpn', v)} />
        </div>
        <div style={row2}>
          <Field label="Agent Phone Number" value={data.agentPhone || '(503) 324-4511'} onChange={v => onChange('agentPhone', v)} />
          <Field label="Agent Email Address" value={data.agentEmail || 'support@translatinginsurance.com'} onChange={v => onChange('agentEmail', v)} />
        </div>
        <div style={row2}>
          <Field label="Name of Agency" value={data.agencyName || 'Translating Insurance'} onChange={v => onChange('agencyName', v)} />
          <Field label="Agency National Producer Number" value={data.agencyNpn || ''} onChange={v => onChange('agencyNpn', v)} />
        </div>
        <div style={row2}>
          <Field label="Owner of Agency" value={data.agencyOwner || 'Jacquie Walter'} onChange={v => onChange('agencyOwner', v)} />
          <Field label="Agency Phone Number" value={data.agencyPhone || '(503) 324-4511'} onChange={v => onChange('agencyPhone', v)} />
        </div>
        <Field label="Agency Email Address" value={data.agencyEmail || 'support@translatinginsurance.com'} onChange={v => onChange('agencyEmail', v)} />
      </div>
    </div>
  );
}

// Shared with ConsentOregon - the e-signature box is identical on both.
export function ConsentSignature({ data, onChange }) {
  const signatureDate = data.consentTimestamp
    ? new Date(data.consentTimestamp).toLocaleDateString('en-US')
    : new Date().toLocaleDateString('en-US');

  function setAgreed(checked) {
    onChange('consentAgreed', checked);
    onChange('consentTimestamp', checked ? new Date().toISOString() : null);
  }

  return (
    <div style={signatureBox}>
      <div style={signatureTitle}>Electronic Signature Agreement</div>
      <label style={agreeRow}>
        <input
          type="checkbox"
          checked={!!data.consentAgreed}
          onChange={e => setAgreed(e.target.checked)}
          style={{ width: 22, height: 22, cursor: 'pointer', accentColor: '#1a3364', marginTop: 0, flex: '0 0 auto' }}
        />
        <span style={{ fontSize: 15, color: '#1a3364', fontWeight: 800, lineHeight: 1.45 }}>
          I agree to use an electronic signature and consent to the terms above.
        </span>
      </label>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14 }}>
        <div>
          <label style={lbl}>Type Your Full Legal Name as Signature</label>
          <input
            style={{ ...inp, fontStyle: 'italic', fontSize: 16, letterSpacing: '0.02em' }}
            placeholder="Full legal name"
            value={data.consentSignature}
            onChange={e => onChange('consentSignature', e.target.value)}
            disabled={!data.consentAgreed}
            {...noAutofill('consent-signature')}
          />
        </div>
        <div>
          <label style={lbl}>Signature Date</label>
          <input
            style={{ ...inp, background: '#e8f0f8', color: '#4a6288', cursor: 'not-allowed' }}
            value={signatureDate}
            readOnly
          />
        </div>
      </div>
    </div>
  );
}

export function Field({ label, value, onChange }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={lbl}>{label}</label>
      <input style={inp} value={value} onChange={e => onChange(e.target.value)} {...noAutofill(label.toLowerCase().replace(/[^a-z0-9]+/g, '-'))} />
    </div>
  );
}

export const copy = { color: '#4a6288', lineHeight: 1.65, fontSize: 14, marginTop: 0 };
export const list = { color: '#4a6288', lineHeight: 1.55, fontSize: 14, paddingLeft: 22 };
const signatureBox = { background: '#fff8e8', border: '2px solid #d89b2b', borderRadius: 10, padding: '18px 20px', marginBottom: 20, boxShadow: '0 8px 24px rgba(26, 51, 100, 0.08)' };
const signatureTitle = { fontSize: 13, fontWeight: 800, color: '#1a3364', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 12 };
const agreeRow = { display: 'flex', alignItems: 'flex-start', gap: 12, cursor: 'pointer', userSelect: 'none', marginBottom: 18 };
export const agentBox = { background: '#f4f8fc', border: '1.5px solid #c5d5e8', borderRadius: 8, padding: 14, marginBottom: 18, color: '#1a3364' };
export const agentTitle = { fontSize: 13, fontWeight: 800, color: '#1a3364', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 12 };
